export const URL = 'https://mayan.cash/';
